import React, { useEffect, useState } from "react";
import { Plus, Trash2, Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, mediaUrl, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import MediaInput from "@/components/admin/MediaInput";

export default function DestinationsAdmin({ onChange }) {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/destinations").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const update = (i, patch) => setList((l) => l.map((d, j) => (j === i ? { ...d, ...patch } : d)));
  const save = async (d) => {
    try {
      if (d.id) await api.put(`/admin/destinations/${d.id}`, { name: d.name, image: d.image, order: Number(d.order) || 0 });
      else await api.post("/admin/destinations", { name: d.name, image: d.image, order: Number(d.order) || 0 });
      toast.success("Destino guardado"); load(); onChange();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (d) => {
    if (d.id) await api.delete(`/admin/destinations/${d.id}`);
    load(); onChange(); toast.success("Destino eliminado");
  };

  if (!list) return <Loader2 className="w-6 h-6 animate-spin brand-text" />;
  return (
    <div className="space-y-4" data-testid="admin-destinations">
      <div className="flex justify-end">
        <button onClick={() => setList([...list, { name: "", image: "", order: list.length + 1 }])} className="btn-brand px-4 py-2 rounded-md font-medium flex items-center gap-2" data-testid="add-destination-btn"><Plus className="w-4 h-4" />Nuevo destino</button>
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        {list.map((d, i) => (
          <div key={d.id || `new-${i}`} className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 flex gap-4" data-testid="destination-row">
            {d.image ? <img src={mediaUrl(d.image)} alt="" className="w-28 h-28 object-cover rounded-lg shrink-0" /> : <div className="w-28 h-28 rounded-lg bg-gray-100 shrink-0" />}
            <div className="flex-1 space-y-2 min-w-0">
              <div className="flex gap-2"><Input value={d.name} onChange={(e) => update(i, { name: e.target.value })} placeholder="Nombre" data-testid="destination-name-input" /><Input type="number" value={d.order} onChange={(e) => update(i, { order: e.target.value })} className="w-20" /></div>
              <MediaInput value={d.image} onChange={(v) => update(i, { image: v })} testid={`destination-${i}`} />
              <div className="flex gap-2">
                <button onClick={() => save(d)} className="btn-brand px-3 py-1.5 rounded-md text-sm flex items-center gap-1.5" data-testid="save-destination-btn"><Save className="w-3.5 h-3.5" />Guardar</button>
                <button onClick={() => remove(d)} className="px-3 py-1.5 rounded-md text-sm text-red-600 border border-red-100 hover:bg-red-50 flex items-center gap-1.5"><Trash2 className="w-3.5 h-3.5" />Eliminar</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
